export default () => {
  const apiRequest = useApiRequest();
  const involvedPersonBaseUrl = 'reports/involvedperson/';
  return {
    /* -------------------------------------------------------------------------- */
    /*                                    Involved Persons                        */
    /* -------------------------------------------------------------------------- */

    /**
     * Gets a list of Persons, potentially filtered.
     *
     * @param filters
     */
    getAllInvolvedPersons: (investigationReportId: number) =>
      apiRequest.get<Page<InvolvedPerson>>(`reports/involvedperson/?investigationreport=${investigationReportId}`),

    /**
     * Creates a new involved person
     *
     * @param report
     */
    createInvolvedPerson: (report: Partial<InvolvedPerson>, id: number) => {
      report.investigationreports = [id];
      return apiRequest.post<InvolvedPerson>(involvedPersonBaseUrl, { body: report });
      // console.log(response);
    },

    /**
     * Get a specific person
     *
     * @param id
     */
    getInvolvedPerson: (id: number) =>
      apiRequest.get<InvolvedPerson>(`${involvedPersonBaseUrl}${id}/`),

    /**
     * Search for persons based on a text string
     *
     * @param id
     */
    searchInvolvedPersons: (params: any) =>
      apiRequest.get<Page<InvolvedPersonSearchResult>>(`${involvedPersonBaseUrl}`, { params }),

    /**
     * Updates a specific person
     *
     * @param id
     */
    updateInvolvedPerson: (id: number, data: Partial<InvestigationReportChanges>) =>
      apiRequest.patch<InvolvedPerson>(`${involvedPersonBaseUrl}${id}/`, { body: data }),

    /**
     * Delete a specific person.
     *
     * @param id
     */
    deleteInvolvedPerson: (id: number) =>
      apiRequest.delete<InvolvedPerson>(`${involvedPersonBaseUrl}${id}/`),

  };
};
